import ProductionControlTimeDetail from '@/models/ProductionControlTime/ProductionControlTimeDetail';

export default class ProductionControlTimeDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.standarTimeIdId  = '';
		this.standarTimeIdStandarTimeName = '';
		this.productionControlTimeId  = '';
		this.productionControlTimeName = '';
		this.standarTimeValue = '';
		this.standarTimeCategory = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			standarTimeIdId : '0',
			standarTimeIdStandarTimeName : '0',
			productionControlTimeId : '0',
			productionControlTimeName : '0',
			standarTimeValue : '0',
			standarTimeCategory : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}